export default "__VITE_ASSET__j3CC_7rK__"